var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Authorized SSID(s)","sub-title":"These SSID(s) are authorized for the users of this organization"}},[_c('AddApprovedSsid'),_c('ApprovedSsidList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }